(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/video-player/assets/javascripts/video-player.js') >= 0) return;  svs.modules.push('/components/components/video-player/assets/javascripts/video-player.js');

'use strict';

const {
  useEffect,
  useRef
} = React;
const VideoPlayer = _ref => {
  let {
    videoId,
    src,
    heightPercent,
    height,
    width,
    title,
    jsonLDTags
  } = _ref;
  const scriptRef = useRef(null);
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = jsonLDTags;
    const currentScriptDiv = scriptRef.current;
    if (currentScriptDiv) {
      currentScriptDiv.appendChild(script);
    }
    return () => {
      if (currentScriptDiv) {
        currentScriptDiv.removeChild(script);
      }
    };
  }, [jsonLDTags]);
  return React.createElement("div", {
    className: "video-container js-video-container",
    "data-videoid": videoId,
    ref: scriptRef,
    style: heightPercent ? {
      paddingBottom: "".concat(heightPercent, "%")
    } : null
  }, React.createElement("iframe", {
    allowFullScreen: true,
    className: "js-solid-iframe js-video-".concat(videoId, " solid-stat"),
    height: height,
    src: src,
    title: title,
    width: width
  }));
};
svs.components.video_player.VideoPlayer = VideoPlayer;

 })(window);